var React = require('react');

function BackendInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.2475 8.835C22.6383 4.2025 18.6716 0.533333 13.9966 0.264167C13.7983 0.25 13.6141 0.25 13.4158 0.25C8.41497 0.25 4.30663 3.9475 3.61247 8.75L0.878299 13.68C0.297466 14.615 0.977466 15.8333 2.08247 15.8333H3.49913V18.6667C3.49913 20.225 4.77413 21.5 6.33247 21.5H7.74913V25.75H17.6658V19.12C21.3775 17.3492 23.8283 13.34 23.2475 8.835ZM16.0933 16.7258L14.8325 17.3208V22.9167H10.5825V18.6667H6.33247V13H4.4908L6.37497 9.69917C6.62997 6.00167 9.66163 3.08333 13.4158 3.08333C17.3258 3.08333 20.4991 6.25667 20.4991 10.1667C20.4991 13.1275 18.6716 15.6633 16.0933 16.7258Z","fill":"#646464"}));
}

BackendInline.defaultProps = {"width":"24","height":"26","viewBox":"0 0 24 26","fill":"none"};

module.exports = BackendInline;

BackendInline.default = BackendInline;
